var path = 'areas/projects/actions/tomcat/Octopus.TomcatState_edit.html';
var html = "<div> <p class=help-block> This step is used to start or stop a deployment in Tomcat.. </p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/tomcat/Octopus.TomcatState_edit.html
// module id = 6641016680430321
// module chunks = 1